<template>
  <div no-body class="my-1 p-1 bg-white">
    <div header-tag="header" class="p-1" role="tab">
      <b-button
        v-b-toggle.accordion-1
        block
        class="d-flex collapseHeadStyle"
        @click="isVisibleFEMA = !isVisibleFEMA"
      >
        <p class="mb-0 text-dark font-weight-bold">FEMA Disaster List</p>
        <strong class="ml-auto"><i :class="`fa fa-angle-${isVisibleFEMA ? 'up' : 'down'} text-dark`"></i></strong>
      </b-button>
    </div>
    <b-collapse id="accordion-1" visible>
      <div v-if="FEMA_ERROR === null">
      <div v-if="femaItems.length" class="mx-1 my-2">
        <b-table
          responsive
          striped
          bordered
          :fields="femaFields"
          :items="femaItems"
          :caption="femaCaption"
          :class="{ 
            'mb-0': !femaItems.length, 
            'fraudReportHeaderTable': true, 
          }"
        >
          <template v-slot:cell(action)>
            <BaseIcon class="statusFail" size="lg" name="times" /> </template
        ></b-table>
      </div>
      <NoRecordFound v-if="!femaItems.length" class="mt-0 mx-1"></NoRecordFound>
      </div>
      <CustomMessage v-else :custom-msg="FEMA_ERROR"/>

    </b-collapse>
  </div>
</template>

<script>
import CustomMessage from '@/src/components/_custom-message.vue'

export default {
  components: {
    CustomMessage,
  },
  props: {
    femaData: {
      type: Array,
      default: () => [],
    },
    femaMessage: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      isVisibleFEMA: false,
      femaItems: [],
      femaNoDataItems: [],
      femaCaption: "* IH - Individual and Households, ** IA - Individual Assistance, *** PA - Public Assistance, **** HM - Hazard Mitigation",
      femaFields: [
        { key: 'location', label: 'Location',
          thClass: 'text-left',
          tdClass: 'textTruncatee',thStyle: { width: '200px' }
        },
        { key: 'disasterTitle', label: 'Disaster Title',
          thClass: 'text-left',
          tdClass: 'textTruncatee',thStyle: { width: '380px' }
        },
        { key: 'femaDeclaration', label: ' FEMA Declaration',
          thClass: 'text-left',
          tdClass: 'textTruncatee',thStyle: { width: '150px' }
        },
        { key: 'incidentType', label: ' Incident Type',
          thClass: 'text-left',
          tdClass: 'textTruncatee',thStyle: { width: '150px' }
        },
        { key: 'incidentDates', label: 'Incident Dates',
          thClass: 'text-left',
          tdClass: 'textTruncatee',thStyle: { width: '200px' }
        },
        { key: 'disasterCloseOutDate', label: 'Disaster Close Out Date',
          thClass: 'text-right',
          tdClass: 'textTruncatee text-right',thStyle: { width: '120px' }
        },
        { key: 'ih', thClass: 'text-left', label: 'IH' },
        { key: 'ia', thClass: 'text-left', label: 'IA' },
        { key: 'pa', thClass: 'text-left', label: 'PA' },
        { key: 'hm', thClass: 'text-left', label: 'HM' },
      ],
    }
  },
  computed: {
    FEMA_ERROR() {
      return this.femaMessage
    },
  },
  mounted() {
    if (this.femaData.length) {
      this.femaData.forEach((item) => {
        if (item.location.toLowerCase().replace(/\s+/g, '') === '') {
          this.femaItems = []
        } else {
          this.femaItems.push({
            action: item.location,
            location: this.formatDisplay(item.location),
            disasterTitle: this.formatDisplay(item.disasterTitle),
            femaDeclaration: this.formatDisplay(item.femaDeclarationString),
            incidentType: this.formatDisplay(item.incidentType),
            incidentDates: this.formatDisplay(item.incidentDates),
            disasterCloseOutDate: this.formatDisplay(item.disasterCloseOutDate),
            ih: this.formatDisplay(item.ih),
            ia: this.formatDisplay(item.ia),
            pa: this.formatDisplay(item.pa),
            hm: this.formatDisplay(item.hm),
          })
        }
      })
    }
  },
  methods: {
    formatDisplay(value) {
      return value || null
    },
    noValueFormat(value) {
      if (value === 'No') return null
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@design';

.statusSuccess {
  color: $color-status-success;
}

.statusFail {
  color: $color-status-fail;
}

.collapseHeadStyle {
  background-color: $color-raisin-40 !important;
  border: none;
}
</style>
